import './MonthPicker.scss'
import { SecondaryButton } from '@entur/button'
import { Dropdown } from '@entur/dropdown'
import { BackArrowIcon, ForwardIcon } from '@entur/icons'
import { space } from '@entur/tokens'
import React from 'react'

type MonthPickerProps = {
  month: number
  year: number
  setYear: (newYear: number) => void
  setMonth: React.Dispatch<React.SetStateAction<number>>
}
export const MonthPicker: React.FC<MonthPickerProps> = ({ month, year, setMonth, setYear }) => {
  const dropdownItems = [
    { value: '0', label: 'Alle' },
    { value: '1', label: 'Januar' },
    { value: '2', label: 'Februar' },
    { value: '3', label: 'Mars' },
    { value: '4', label: 'April' },
    { value: '5', label: 'Mai' },
    { value: '6', label: 'Juni' },
    { value: '7', label: 'Juli' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'Oktober' },
    { value: '11', label: 'November' },
    { value: '12', label: 'Desember' },
  ]

  function range(start: number, end: number) {
    return Array(end - start + 1)
      .fill(0)
      .map((_, idx) => (start + idx).toString())
  }

  const yearDropdownItems = range(2021, new Date().getFullYear() + 1)

  const changeMonth = (newMonth: number) => {
    if (newMonth < 1) {
      setMonth(12)
      setYear(year - 1)
    } else if (newMonth > 12) {
      setMonth(1)
      setYear(year + 1)
    } else {
      setMonth(newMonth)
    }
  }

  const disableButtons = month === 0
  const selectedMonthItem = dropdownItems.find((item) => item.value === month.toString()) ?? null
  const selectedYearItem = { label: year.toString(), value: year.toString() }

  return (
    <div className="boxes" style={{ marginTop: space.small }}>
      <div className="back-btn">
        <SecondaryButton
          data-cy="month-picker-previous-button"
          onClick={() => changeMonth(month - 1)}
          disabled={disableButtons || (year === 2021 && month === 1)}
        >
          <BackArrowIcon /> Forrige måned
        </SecondaryButton>
      </div>
      <div data-cy="month-picker-month-dropdown">
        <Dropdown<string>
          className="month-btn"
          items={dropdownItems}
          label="Måned"
          selectedItem={selectedMonthItem}
          onChange={(e) => {
            if (e) setMonth(parseInt(e.value, 10))
          }}
        />
      </div>

      <div data-cy="month-picker-year-dropdown">
        <Dropdown<string>
          className="year-btn"
          items={yearDropdownItems}
          label="År"
          selectedItem={selectedYearItem}
          onChange={(e) => {
            if (e) setYear(parseInt(e.value, 10))
          }}
        />
      </div>
      <SecondaryButton
        data-cy="month-picker-next-button"
        className="forward-btn"
        onClick={() => changeMonth(month + 1)}
        disabled={disableButtons || (year === new Date().getFullYear() + 1 && month === 12)}
      >
        Neste måned <ForwardIcon />
      </SecondaryButton>
    </div>
  )
}
